import { ChallengeReward, ImageUpload } from '../types';
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators';

import { StateController } from '../helpers/state/state-management/state-controller';
import pointCache from '../helpers/state/point-cache';
import topicData from '../helpers/state/topic-data';

@customElement('edit-challenge-rewards')
export class EditChallengeRewards extends LitElement {
    amplitude_callsite: string = 'Challenge Reward Item';



    @property()
    allData: ChallengeReward[] = [];

    @property()
    data?: ChallengeReward;

    @property()
    activeIndex: number = 0;

    @property()
    images: Array<ImageUpload | undefined> = [];

    @property()
    showSave: boolean = true;

    @state()
    canDelete: boolean = true;

    @state()
    challengeReward?: ChallengeReward;

    @state()
    newChallengeRewards: ChallengeReward[] = [];

    @state()
    imagesToUpload: Array<ImageUpload | undefined> = [];

    private readonly bindTopicState = new StateController(this, topicData);
    private readonly bindPointState = new StateController(this, pointCache);

    updated(changedProperties: any) {
        changedProperties.forEach((oldValue: any, propName: any) => {
            if(propName === 'data' || propName === 'activeIndex') {
                this.challengeReward = this.data as ChallengeReward;
            } else if (propName === 'allData') {
                this.newChallengeRewards = this.allData;
            } else if (propName === 'images') {
                this.imagesToUpload = this.images;
            }
        });
    }

    async onChange(e: CustomEvent) {
        const updatedValue = e.detail.data;
        this.challengeReward = updatedValue;
        if (this.activeIndex && this.newChallengeRewards?.length > 0 && this.challengeReward) {
            this.newChallengeRewards[this.activeIndex] = this.challengeReward;
        }
    }

    async onChangeChallengeRewardImage(e: CustomEvent) {
        this.imagesToUpload[this.activeIndex] = e.detail?.imageToUpload;
    }

    render() {
        return html`
            <div class="edit__container">
                <span class="edit__content">

                    <challenge-reward-form
                        .allData="${this.allData}"
                        .data=${this.challengeReward}
                        @on-change-value=${this.onChange}
                        @on-change-reward-image=${this.onChangeChallengeRewardImage}
                    ></challenge-reward-form>

                    <div class="edit__actions">

                        <form-button class="${this.showSave ? 'edit__delete' : 'edit__delete--only'}" @click="${this.delete}" ?disabled=${!this.canDelete}>
                            Delete
                        </form-button>
                        ${this.showSave ?
                            html`<form-button
                                    raised
                                    class="edit__save"
                                    @click="${this.save}"
                                    ?disabled=${this.challengeReward?.title === undefined}>
                                    Save
                        </form-button>`
                            : ''
                        }
                    </div>
                    ${this.showSave ?
                        html``
                        : ''
                    }
                </span>
                ${this.showSave ? html`<mwc-icon-button class="edit__close" icon="close" @click="${this.closeSelf}"></mwc-icon-button>` : ''}
            </div>

            <error-toast id="errorToast"></error-toast>
        `;
    }

    protected closeSelf() {
        this.dispatchEvent(new CustomEvent('closeDrawer', {
            bubbles: true,
            composed: true,
        }));

        // this is for mobile - coming from a diff flow
        this.dispatchEvent(new CustomEvent('on-close', {
            bubbles: true,
            composed: true,
        }));
    }

    private async save() {
        this.dispatchEvent(new CustomEvent('on-save-changes', {
            detail: {
                newData: this.newChallengeRewards,
                imagesToUpload: this.imagesToUpload,
            }
        }));

        this.closeSelf();
    }

    private async delete() {
        if (confirm('Are you sure you want to delete this challenge reward? This action cannot be undone. Existing users will lose this reward.')) {
            const newChallengeRewards = this.allData.filter((c, index) => index !== this.activeIndex);
            const imagesToUpload = this.imagesToUpload.filter((c, index) => index !== this.activeIndex);
            this.newChallengeRewards = newChallengeRewards;
            this.imagesToUpload = imagesToUpload;

            await this.save();
        }
    }

    static get styles() {
        return css`
            .edit__container {
                width: 100%;
                margin-top: 16px;
                display: flex;
                border-radius: 6px;
                border: 1px solid var(--theme-border-color);
            }

            .edit__content {
                padding-top: 12px;
                padding-bottom: 12px;
                padding-left: 16px;
                width: 100%;
            }

            .edit__actions {
                display: flex;
                justify-content: space-between;
                margin-top: 16px;
            }

            .edit__save {
                --mdc-theme-primary: var(--main-success-color);
            }

            .edit__delete {
                --mdc-theme-primary: var(--main-invalid-color);;
            }

            .edit__close {
                --mdc-icon-size: 24px;
                --mdc-icon-button-size: 18px;
                padding: 4px 2px 2px 2px;
            }

        `;
    }
}